const tableTitleVerification = {
  title: 'Grupos Checklist',
  placeholder: 'Búsqueda por grupos de checklist',
  Typography: 'Ningún resultado encontrado'
};

export default tableTitleVerification;

